var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ImageComponent } from '../../../common/components/image/image.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { ModalService } from '../../../common/services/modal.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ConfigService } from '../../../services/config.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { config } from '../../../../config/config';
import { AllFrontendSettingsStore, VisitorDataCache, } from '../../../stores/visitor.calendar.store';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../hub/show.info.modal/show.info.modal.provider';
import { Analytics } from '../place.details.modal/place.details.modal.component';
import { EventDetailsModalActions } from './event.details.modal.provider';
import { SeoService } from '../../../services/seo.service';
import { VisitorSettingsCommand } from '../../../commands/pagination.query.command';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
var EventDetailsModalComponent = /** @class */ (function (_super) {
    __extends(EventDetailsModalComponent, _super);
    function EventDetailsModalComponent(dialogRef, actions, visitorApiService, modalService, location, allFrontendSettingsStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.visitorApiService = visitorApiService;
        _this.modalService = modalService;
        _this.location = location;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.isLoadingAllEvents = false;
        _this.isLoadingEvent = true;
        _this.isTripPlannerOn = false;
        _this.mapZoom = 16;
        _this.hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
        _this.customBtnContainsThisEvent = null;
        _this.USCenterLat = config.google.USCenter.lat;
        _this.USCenterLng = config.google.USCenter.lng;
        _this.analytics = new EventAnalytics();
        _this.settingsCommand = new VisitorSettingsCommand();
        _this.isNeedScroll = false;
        _this.stepPx = 30;
        _this.timeMousemoveInterval = null;
        _this.displayDescription = '';
        _this.toggles = new HubVisitorFeatureToggle();
        _this.hubName = data.hubName;
        if (data && data._id && !data.startTime) {
            // eventId, from VisitorCalendarComponent
            _this.loadEvents(data._id, data.hubName);
        }
        else {
            _this.loadItem(data);
        }
        var settingStorage = localStorage.getItem(localStorageKeys.visitorSettings);
        if (!settingStorage) {
            settingStorage = localStorage.getItem(localStorageKeys.allFrontendSettingsForTP);
        }
        if (settingStorage) {
            var visitorSettings = JSON.parse(settingStorage);
            _this.settingsCommand = visitorSettings;
        }
        _this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(_this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                _this.toggles = command.toggle;
            }
        });
        return _this;
    }
    EventDetailsModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    Object.defineProperty(EventDetailsModalComponent.prototype, "needReadMore", {
        get: function () {
            if (this.event.socialName && this.event.socialName.includes('serp'))
                return false;
            return this.displayDescription && this.description && this.isEllipsisActive(this.description.nativeElement);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventDetailsModalComponent.prototype, "isMultiLinesTitle", {
        get: function () {
            if (!this.eventTitle)
                return false;
            return this.eventTitle.nativeElement.getBoundingClientRect().height > 60;
        },
        enumerable: true,
        configurable: true
    });
    EventDetailsModalComponent.prototype.isEllipsisActive = function (e) {
        if (!e)
            return false;
        return e.offsetHeight < e.scrollHeight;
    };
    Object.defineProperty(EventDetailsModalComponent.prototype, "normalTicketUri", {
        get: function () {
            // return this.event && this.event.ticketUri && (!this.event.ticketInfo || !this.event.ticketInfo.length);
            return (this.event &&
                this.event.ticketUri &&
                (!this.event.ticketInfo ||
                    !this.event.ticketInfo.length ||
                    this.event.ticketUri !== this.event.ticketInfo[0].link));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventDetailsModalComponent.prototype, "isSmallView", {
        get: function () {
            // return !this.mediaQueryService.isPC;
            // all use small view design now
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventDetailsModalComponent.prototype, "processedTicketUri", {
        get: function () {
            var noSchema = this.event.ticketUri.replace('https://', '');
            noSchema = noSchema.replace('http://', '');
            noSchema = noSchema.replace('www.', '');
            return noSchema.split('/')[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventDetailsModalComponent.prototype, "venueName", {
        get: function () {
            if (!this.event)
                return '';
            return (this.event.venue ||
                (this.event.venueInfo && this.event.venueInfo.name) ||
                (this.event.owner && this.event.owner.name));
        },
        enumerable: true,
        configurable: true
    });
    EventDetailsModalComponent.prototype.getLink = function (link) {
        if (link && !link.startsWith('http')) {
            return "http://" + link;
        }
        return link;
    };
    EventDetailsModalComponent.prototype.getString = function (obj) {
        return JSON.stringify(obj);
    };
    EventDetailsModalComponent.prototype.openTicketUrl = function (link) {
        window.open(link.startsWith('http') ? link : "https://" + link, '_blank');
    };
    EventDetailsModalComponent.prototype.confirm = function (event) {
        this.actions.confirm(event);
        this.dialogRef.close();
    };
    EventDetailsModalComponent.prototype.onUpcomingEventClick = function () {
        // close current
        this.dialogRef.close();
    };
    Object.defineProperty(EventDetailsModalComponent.prototype, "isLongDescriptionArea", {
        get: function () {
            return this.event && this.event.eventTimes.length <= 2;
        },
        enumerable: true,
        configurable: true
    });
    EventDetailsModalComponent.prototype.loadEvents = function (eventId, hubName) {
        var _this = this;
        // let allEventsWithCurrent = JSON.parse(localStorage.getItem(localStorageKeys.visitorEvents));
        var allEventsWithCurrent = VisitorDataCache.events;
        var exist = allEventsWithCurrent && allEventsWithCurrent.length
            ? allEventsWithCurrent.first(function (x) { return x._id === (eventId || _this.event._id); })
            : null;
        if (!this.event && !exist) {
            this.getEventById(hubName, eventId || this.event._id).subscribe(function (p) {
                _this.isLoadingEvent = false;
                if (p && p.length) {
                    p[0].hubName = hubName;
                    _this.loadItem(p[0]);
                    _this.isLoadingAllEvents = true;
                    _this.getEvents(hubName).subscribe(function (data) {
                        _this.isLoadingAllEvents = false;
                        // localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(data));
                        VisitorDataCache.events = data;
                    });
                }
                else {
                    _this.modalService.showErrorModal('Uh-oh! Looks like this event has already happened! But don’t worry, we have more exciting events you can check on our calendar', 'View All Upcoming Events');
                    _this.close();
                }
                return;
            });
        }
        else {
            exist.hubName = hubName;
            this.loadItem(exist);
        }
    };
    EventDetailsModalComponent.prototype.visitWebsite = function () {
        if (this.event.eventLink || this.event.hostLink) {
            var target = this.event.eventLink || this.event.hostLink;
            target = target.startsWith('http') ? target : "https://" + target;
            window.open(target, '_blank');
        }
        this.addBuyTicketCount();
    };
    EventDetailsModalComponent.prototype.getDirection = function () {
        var address = this.event.address.address || this.event.address;
        var url = config.eventShare.googleMapGetDirection.replace('${address}', encodeURIComponent(address.toString()));
        window.open(url, '_blank');
        this.addGetDirectionCount();
    };
    /**
     * handle browser back button click, close the event details page
     * only close the details page is not enough, it will always have other loading issues for the script embedding solution
     * so force reload the page for now
     * */
    EventDetailsModalComponent.prototype.hashChanged = function ($event) {
        $event.preventDefault();
        console.log('prevent default');
        var url = window.location.href.split('imgoing-event')[0];
        url = url.endsWith('?') ? url.substring(0, url.length - 1) : url;
        window.location.href = url;
        this.close();
    };
    EventDetailsModalComponent.prototype.loadItem = function (event) {
        var _this = this;
        if (!event) {
            return;
        }
        this.event = event;
        this.imgComp && this.imgComp.updateImage(event.cover && event.cover.source);
        !this.event.isOnlineEvent && this.processAddress();
        this.processDescription();
        this.loadCustomBtns();
        if (!this.isScriptSolution) {
            SeoService.addNameIdToUrlForNonScriptSolution(this.location, event, this.dialogRef);
        }
        else {
            // for clients who use the whole html page solution (we give them a whole page that wraps ImGoing)
            // change the URL by adding the ImGoing event name + Id to the params so that each place has a unique URL
            // when close the details modal, reset the URL to the original URL of the host site
            if (SeoService.getIfNeedToAddNameIdToUrl()) {
                SeoService.addNameIdToUrlForScriptSolution(event, this.dialogRef);
            }
        }
        this.isLoadingEvent = false;
        setTimeout(function () {
            _this.setEleStyle();
            SeoService.createAndInjectGoogleStructureDataScriptForEvent(_this.event);
            _this.getIsNeedScroll();
        }, 300);
    };
    EventDetailsModalComponent.prototype.showEventLink = function () {
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Event Link', null, ["" + config.serverDomain + this.event.hubName + "/event-details/" + this.event._id], null, true),
                },
            ],
            panelClass: 'width-modal-4',
        });
    };
    EventDetailsModalComponent.prototype.addBuyTicketCount = function () {
        this.analytics.gotoBuyTicketCount++;
    };
    EventDetailsModalComponent.prototype.addGetDirectionCount = function () {
        this.analytics.getDirectionCount++;
    };
    EventDetailsModalComponent.prototype.addShareEmail = function () {
        this.analytics.shareEmailCount++;
    };
    EventDetailsModalComponent.prototype.addShareFB = function () {
        this.analytics.shareFBCount++;
    };
    EventDetailsModalComponent.prototype.addShareTweet = function () {
        this.analytics.shareTweetCount++;
    };
    EventDetailsModalComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        console.log('destroy', this.analytics);
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateEventAnalytics(this.hubName, this.event._id, this.analytics).subscribe();
        }
    };
    EventDetailsModalComponent.prototype.goLeft = function () {
        var _this = this;
        var x = 0;
        var interval = setInterval(function () {
            _this.timeWrap.nativeElement.scrollBy(_this.stepPx * -1, 0);
            x = x + _this.stepPx;
            if (x >= 192) {
                clearInterval(interval);
            }
        }, 5);
    };
    EventDetailsModalComponent.prototype.goRight = function () {
        var _this = this;
        var x = 0;
        var interval = setInterval(function () {
            _this.timeWrap.nativeElement.scrollBy(_this.stepPx, 0);
            x = x + _this.stepPx;
            if (x >= 192) {
                clearInterval(interval);
            }
        }, 5);
    };
    EventDetailsModalComponent.prototype.scrollLeft = function () {
        var _this = this;
        this.clearTimeMousemoveInterval();
        this.timeMousemoveInterval = setInterval(function () {
            _this.timeWrap.nativeElement.scrollBy(_this.stepPx * -1, 0);
        }, 23);
    };
    EventDetailsModalComponent.prototype.scrollRight = function () {
        var _this = this;
        this.clearTimeMousemoveInterval();
        this.timeMousemoveInterval = setInterval(function () {
            _this.timeWrap.nativeElement.scrollBy(_this.stepPx, 0);
        }, 23);
    };
    EventDetailsModalComponent.prototype.clearTimeMousemoveInterval = function () {
        clearInterval(this.timeMousemoveInterval);
    };
    Object.defineProperty(EventDetailsModalComponent.prototype, "isAtStart", {
        get: function () {
            if (!this.timeWrap)
                return true;
            var scrollLeft = this.timeWrap.nativeElement.scrollLeft;
            return scrollLeft === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventDetailsModalComponent.prototype, "isAtEnd", {
        get: function () {
            if (!this.timeWrap)
                return false;
            var _a = this.timeWrap.nativeElement, scrollWidth = _a.scrollWidth, scrollLeft = _a.scrollLeft, clientWidth = _a.clientWidth;
            return scrollWidth - (scrollLeft + clientWidth) <= 10;
        },
        enumerable: true,
        configurable: true
    });
    EventDetailsModalComponent.prototype.scrollToStart = function () {
        if (this.timeWrap) {
            this.timeWrap.nativeElement.scroll(0, 0);
        }
    };
    EventDetailsModalComponent.prototype.getIsNeedScroll = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.timeWrap) {
                var scrollWidth = _this.timeWrap.nativeElement.scrollWidth;
                var clientWidth = _this.timeWrap.nativeElement.clientWidth;
                console.log("scrollWidth: " + scrollWidth + ", clientWidth: " + clientWidth);
                _this.isNeedScroll = scrollWidth > clientWidth;
            }
        });
    };
    EventDetailsModalComponent.prototype.showDescription = function () {
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Event Description', [], [this.event.description]),
                },
            ],
            panelClass: 'width-modal-4',
        });
    };
    EventDetailsModalComponent.prototype.setEleStyle = function () {
        this.isLoadingAllEvents = false;
        this.mapColumnEle.nativeElement.style.height = '653px';
        this.descriptionEle.nativeElement.style.display = 'block';
        this.descriptionEle.nativeElement.style.height = '653px';
        this.description.nativeElement.scrollTop = 0;
    };
    EventDetailsModalComponent.prototype.processAddress = function () {
        var addSegs = this.event.address.address.split(',');
        var last = addSegs[addSegs.length - 1];
        var cityArr = [], no = [];
        var take = parseInt(last, 10) ? 3 : 2;
        addSegs.forEach(function (x, index) {
            if (index < addSegs.length - take) {
                if (x.length <= 3 && no.length > 0) {
                    // if the address segment is less than 3 chars, it usually means the state name, connect it with the previous segment
                    no[no.length - 1] = no[no.length - 1] + ", " + x;
                }
                else {
                    no.push(x);
                }
            }
            else {
                cityArr.push(x);
            }
        });
        this.addressSegs = no.concat([cityArr.join(', ')]);
    };
    EventDetailsModalComponent.prototype.processDescription = function () {
        if (this.event.description && this.event.socialName && this.event.socialName.includes('serp')) {
            this.displayDescription = this.event.description;
            // if (!this.displayDescription.endsWith('read more</a>')) {
            if (this.displayDescription.endsWith('...')) {
                this.displayDescription += "&nbsp;<a href=\"" + this.event.eventLink + "\" target=\"_blank\">read more</a>";
            }
            return;
        }
        if (this.event.description) {
            if (!this.displayDescription.endsWith('read more</a>')) {
                // remove html tags
                var regex = /(<([^>]+)>)/gi;
                this.displayDescription = this.event.description.replace(regex, '');
            }
        }
    };
    EventDetailsModalComponent.prototype.loadCustomBtns = function () {
        var _this = this;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.customSettings) {
                _this.customEvents = command.customSettings.customEvents || null;
                if (_this.customEvents && _this.customEvents.length) {
                    _this.customBtnContainsThisEvent = _this.customEvents.filter(function (x) {
                        return x.events.any(function (y) { return y === _this.event._id; });
                    });
                }
            }
            if (command.toggle) {
                _this.isTripPlannerOn = command.toggle.tripPlanner;
            }
        });
    };
    EventDetailsModalComponent.prototype.getEvents = function (hubName) {
        return this.visitorApiService.getEvents(hubName || this.event.hubName, { page: 1, limit: 1000 });
    };
    EventDetailsModalComponent.prototype.getEventById = function (hubName, id) {
        return this.visitorApiService.getEvents(hubName || this.event.hubName, {
            page: 1,
            limit: 1,
            id: id,
        });
    };
    return EventDetailsModalComponent;
}(BaseComponent));
export { EventDetailsModalComponent };
var EventAnalytics = /** @class */ (function (_super) {
    __extends(EventAnalytics, _super);
    function EventAnalytics() {
        var _this = _super.call(this) || this;
        _this.gotoBuyTicketCount = 0;
        return _this;
    }
    return EventAnalytics;
}(Analytics));
export { EventAnalytics };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.details.modal/event.details.modal.component.ts.pre-build-optimizer.js